import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
const FormStack = ({ children, }) => (_jsx(Stack, { direction: "column", spacing: 2, sx: { width: '100%' }, alignItems: "flex-start", children: children }));
export default FormStack;
//# sourceMappingURL=FormStack.js.map